export default __webpack_public_path__ + "static/media/Group_8345.1fcd7eee.svg";